import React, { useState, useRef } from "react";
import ChartPageLayout from "../components/Layout/ChartPageLayout";

const StrengthOfSchedule = () => {
  localStorage.setItem('managerToggleState', JSON.stringify(false));
  const refreshOnlyOnClickState = (localStorage.getItem('refreshOnlyOnClick') ?? true);

  // Chart variables
  const [chartData1, setChartData1] = useState({labels: [], datasets: [{label: ['Schedule Matrix'], data: [], backgroundColor: []},]});
  const [chartData2, setChartData2] = useState({labels: [], datasets: [{label: [], data: [], backgroundColor: []},]});
  const [chartData3, setChartData3] = useState({labels: [], datasets: [{label: [], data: [], backgroundColor: []},]});
  const chartRef1 = useRef(null);
  const chartRef2 = useRef(null);
  const chartRef3 = useRef(null);
  const [descriptionText1, setDescriptionText1] = useState('')
  const [descriptionText2, setDescriptionText2] = useState('')
  const [descriptionText3, setDescriptionText3] = useState('')
  const [isLoading1, setIsLoading1] = useState(false)
  const [isLoading2, setIsLoading2] = useState(false)
  const [isLoading3, setIsLoading3] = useState(false)
  const [waiting1, setWaiting1] = useState(false)
  const [waiting2, setWaiting2] = useState(false)
  const [waiting3, setWaiting3] = useState(false)

  // Configure charts
  const chartConfigs = [
    { type: 'bubble', data: chartData1, setData: setChartData1, chartRef: chartRef1, id:1, title: 'Schedule Matrix', 
    descriptionText: descriptionText1, setDescriptionText: setDescriptionText1, isLoading: isLoading1, setIsLoading: setIsLoading1, waiting: waiting1, setWaiting: setWaiting1, 
    xTitle: "With This Manager's Schedule", yTitle: "How Would This Manager Do", xLabel: [], yLabel: [] },
    { type: 'bar', data: chartData2, setData: setChartData2, chartRef: chartRef2, id:2, title: 'Points Scored Against', 
    descriptionText: descriptionText2, setDescriptionText: setDescriptionText2, isLoading: isLoading2, setIsLoading: setIsLoading2, waiting: waiting2, setWaiting: setWaiting2 },
    { type: 'bar', data: chartData3, setData: setChartData3, chartRef: chartRef3, id:3, title: 'Points Scored Differential', 
    descriptionText: descriptionText3, setDescriptionText: setDescriptionText3, isLoading: isLoading3, setIsLoading: setIsLoading3, waiting: waiting3, setWaiting: setWaiting3 },
    // Add more chart configurations as necessary
  ];
 
  // Fetch data - 1 api call per chart
  const fetchDataFunctions = [
    () => fetch(`${process.env.REACT_APP_BACKEND_URL}/schedule_compare`).then(response => response.json()),
    () => fetch(`${process.env.REACT_APP_BACKEND_URL}/points_against`).then(response => response.json()),
    () => fetch(`${process.env.REACT_APP_BACKEND_URL}/points_against`).then(response => response.json())
  ];


  // Declare individual functions for each chart
  const getDataChart1 = (filteredData, managerToggle, userName) => {
    const map = {};
    const baseManagers = new Set();
    const scheduleManagers = new Set();

    filteredData.forEach((item) => {
      const { base_manager, schedule_manager, win_lose } = item;

      const key = `${base_manager}-${schedule_manager}`;
      if (!map[key]) {
        map[key] = { count: 0, total: 0 };
      }
        map[key].count++;
        map[key].total += win_lose;
        baseManagers.add(base_manager);
        scheduleManagers.add(schedule_manager);
    });
    
    const baseManagersArr = [...baseManagers];
    const scheduleManagersArr = [...scheduleManagers];
    const bubbles = [];
    const backgroundColors = [];
    const labels = [];
        Object.keys(map).forEach(key => {
            const [base_manager, schedule_manager] = key.split('-');
            const avg = map[key].total / map[key].count;
            // const avg = map[key].total;
            const color = map[key].total > (map[key].count / 2) ? '#81b1d2' : '#fa8174';
            bubbles.push({
                x: (scheduleManagersArr.indexOf(schedule_manager)),
                // x: schedule_manager,
                y: (baseManagersArr.indexOf(base_manager)),
                r: Math.max(Math.min((avg * 20), 18), 3).toFixed(0), // adjust bubble size
                // r: Math.max(Math.min((avg), 18), 3).toFixed(0), // adjust bubble size
                backgroundColor: color,
            });
            labels.push(`${base_manager}-${schedule_manager} ${map[key].total} wins; ${map[key].count-map[key].total} losses`)
            backgroundColors.push(color)
        });
  
    return {
      labels: labels,
      datasets: [{
        label: 'x, y, s',
        data: bubbles,
        backgroundColor: backgroundColors,
        borderWidth: 1,
      }],
    };
  }

  const getDataChart2 = (filteredData, managerToggle, userName) => {
    const groupedData = {};
  
    filteredData.forEach((item) => {
      const { base_manager, points_against, score_diff } = item;
  
      if (!groupedData[base_manager]) {
        groupedData[base_manager] = 0;
      }
  
      groupedData[base_manager] -= points_against;
    });
  
    const sortedData = Object.entries(groupedData).sort((a, b) => b[1] - a[1]);
  
    const backgroundColors = sortedData.map(([key, value]) => {
      let color = value >= 0 ? "#81b1d2" : "#fa8174";
      color = key === userName ? "#74fa9c" : color;
      return color;
    });
  
    return {
      labels: sortedData.map(([key, _]) => key),
      datasets: [{
        label: 'Points Against',
        data: sortedData.map(([_, value]) => value),
        backgroundColor: backgroundColors,
        borderWidth: 1,
      }],
    };
  }

  const getDataChart3 = (filteredData, managerToggle, userName) => {
    const groupedData = {};
  
    filteredData.forEach((item) => {
      const { base_manager, points_against, score_diff } = item;
  
      if (!groupedData[base_manager]) {
        groupedData[base_manager] = 0;
      }
  
      groupedData[base_manager] += score_diff;
    });
  
    const sortedData = Object.entries(groupedData).sort((a, b) => b[1] - a[1]);
  
    const backgroundColors = sortedData.map(([key, value]) => {
      let color = value >= 0 ? "#81b1d2" : "#fa8174";
      color = key === userName ? "#74fa9c" : color;
      return color;
    });
  
    return {
      labels: sortedData.map(([key, _]) => key),
      datasets: [{
        label: 'Point Difference',
        data: sortedData.map(([_, value]) => value),
        backgroundColor: backgroundColors,
        borderWidth: 1,
      }],
    };
  }


  // Put transformations in an array, corresponding to each api call and chart
  const transformFunctions = [
    (filteredData, managerToggle, selectedUser, userName) => {
        return getDataChart1(filteredData, managerToggle, userName)
    },
    (filteredData, managerToggle, selectedUser, userName) => {
        return getDataChart2(filteredData, managerToggle, userName)
    },
    (filteredData, managerToggle, selectedUser, userName) => {
        return getDataChart3(filteredData, managerToggle, userName)
    }
  ];

  // Grab the latest description from the database or create a new description 
  const retrieveDescription = async (chartId, selectedSeason, selectedWeek, selectedPosition, managerToggle, selectedUser, activePage, userName) => {
    const chartToUpdate = chartConfigs.find(chart => chart.id === chartId);
    chartToUpdate.setIsLoading(true); // Start loading when button is clicked
    chartToUpdate.setWaiting(true);
    
    let response;
    try {
      const filters = { season: selectedSeason, week: selectedWeek, position: selectedPosition, manager: managerToggle, lineChartName: selectedUser, page: activePage};
      response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/retrieve_description?chartId=${chartId}&userName=${userName}&filters=${JSON.stringify(filters)}`);

      // Checking if the content type indicates a stream
      if ((response.headers.get('Content-Type').includes('text/event-stream')) && (refreshOnlyOnClickState === 'false')) {
          // Handle streaming here
          const eventSource = new EventSource(response.url);

          let accumulatedData = '';
          eventSource.onmessage = (event) => {
              chartToUpdate.setDescriptionText(event.data);
              chartToUpdate.setWaiting(false);
          };

          eventSource.onerror = (error) => {
              console.error("Error in EventSource:", error);
              eventSource.close();
          };

          eventSource.onopen = (event) => {
              chartToUpdate.setIsLoading(false);
          };

          return;
      }

      // If not streaming, then handle as regular JSON response
      if (refreshOnlyOnClickState === 'false') {
        const newDescription = await response.json();
        if (chartToUpdate && chartToUpdate.setDescriptionText) {
          chartToUpdate.setDescriptionText(newDescription);
        } else {
          console.error(`Chart with ID ${chartId} not found or it has no setDescriptionText function.`);
        }
      }

      } catch (error) {
        console.error("Error refreshing description:", error);
      } finally {
        if (!response.headers.get('Content-Type').includes('text/event-stream')) {
          chartToUpdate.setWaiting(false);
          chartToUpdate.setIsLoading(false); // Stop loading if it's not a stream
        }
      }
      chartToUpdate.setWaiting(false);
      chartToUpdate.setIsLoading(false);
    };


  return (
    <div className="strengthofschedule">
        <ChartPageLayout fetchDataFunctions={fetchDataFunctions} transformFunctions={transformFunctions} chartConfigs={chartConfigs} 
                         activePage={'strength_of_schedule'} pageTitle={'Strength of Schedule'} retrieveDescription={retrieveDescription}
        >
        </ChartPageLayout>
    </div>
    );
};

export default StrengthOfSchedule;

